import { mapaOperacional } from "@/mocks/dashboard";
import { useNavigate } from "react-router-dom";

const tipoConfig: Record<string, { cor: string; label: string }> = {
  saudavel: { cor: "#1B6E4F", label: "Saudável" },
  medio: { cor: "#FBC02D", label: "Risco Médio" },
  alto: { cor: "#F57C00", label: "Risco Alto" },
  critico: { cor: "#D32F2F", label: "Risco Crítico" },
  areaVerde: { cor: "#0052CC", label: "Área Verde / UC" },
};

export default function MapaOperacional() {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-card border border-background-200 overflow-hidden">
      <div className="flex items-center justify-between px-5 pt-5 pb-3">
        <div>
          <h3 className="text-sm font-semibold text-foreground-900 font-heading">Mapa Operacional</h3>
          <p className="text-xs text-foreground-500 mt-0.5">Distribuição espacial dos pontos arbóreos</p>
        </div>
        <button
          onClick={() => navigate("/mapa")}
          className="btn-primary text-xs px-3 py-1.5 cursor-pointer"
        >
          <i className="ri-map-2-line"></i>
          Abrir Mapa Arbóreo
        </button>
      </div>

      {/* Simulated Map Area */}
      <div className="relative bg-background-100 mx-5 rounded-lg overflow-hidden" style={{ height: "260px" }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14628.302912345678!2d-46.636!3d-23.5505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1spt-BR!2sbr!4v1690000000000"
          width="100%"
          height="260"
          style={{ border: 0, filter: "saturate(0.85)" }}
          allowFullScreen={false}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Mapa operacional FloraIQ - Pontos arbóreos georreferenciados"
          className="grayscale-[0.3]"
        ></iframe>

        {/* Overlay dots */}
        <div className="absolute inset-0 pointer-events-none">
          {mapaOperacional.pontos.map((ponto, i) => {
            const config = tipoConfig[ponto.tipo];
            const top = 20 + ((ponto.lat + 23.562) / 0.025) * 220;
            const left = 10 + ((ponto.lng + 46.644) / 0.02) * 90;

            return (
              <div
                key={i}
                className="absolute group cursor-default pointer-events-auto"
                style={{ top: `${Math.min(Math.max(top, 5), 245)}px`, left: `${Math.min(Math.max(left, 5), 95)}%` }}
              >
                <div
                  className="w-3 h-3 rounded-full border-2 border-white shadow-sm transition-transform hover:scale-150"
                  style={{ backgroundColor: config.cor }}
                  title={`${ponto.label} (${ponto.codigo})`}
                ></div>
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block">
                  <span className="bg-foreground-900 text-white text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap">
                    {ponto.label} · {ponto.codigo}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Legend */}
      <div className="px-5 py-3 flex items-center gap-4 flex-wrap">
        {Object.entries(tipoConfig).map(([key, config]) => (
          <div key={key} className="flex items-center gap-1.5">
            <span
              className="w-2.5 h-2.5 rounded-full shrink-0"
              style={{ backgroundColor: config.cor }}
            ></span>
            <span className="text-xs text-foreground-600 whitespace-nowrap">{config.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}